/**
 * @param seats
 * @param trial
 */
class AddSeatsModalConfirmed {
    eventProperties;
    eventName = "add_seats_modal_confirmed";
    constructor(props) {
        this.eventProperties = {
            seats: props.seats ?? undefined,
            trial: props.trial ?? undefined,
        };
    }
}
/** @param location */
class ApplePayButtonClicked {
    eventProperties;
    eventName = "apple_pay_button_clicked";
    constructor(props) {
        this.eventProperties = {
            location: props.location,
        };
    }
}
/** @param location */
class ApplePaySetupFailed {
    eventProperties;
    eventName = "apple_pay_setup_failed";
    constructor(props) {
        this.eventProperties = {
            location: props.location,
        };
    }
}
/**
 * @param fbclid
 * @param gclid
 * @param utmCampaign
 * @param utmMedium
 * @param utmSource
 */
class CampaignTouched {
    eventProperties;
    eventName = "campaign_touched";
    constructor(props) {
        this.eventProperties = {
            fbclid: props.fbclid ?? undefined,
            gclid: props.gclid ?? undefined,
            utm_campaign: props.utmCampaign ?? undefined,
            utm_medium: props.utmMedium ?? undefined,
            utm_source: props.utmSource ?? undefined,
        };
    }
}
/**
 * @param answerId
 * @param targetUrl
 */
class ChatbotAnswerLinkClicked {
    eventProperties;
    eventName = "chatbot_answer_link_clicked";
    constructor(props) {
        this.eventProperties = {
            answer_id: props.answerId,
            target_url: props.targetUrl,
        };
    }
}
/**
 * @param action
 * @param answerId
 */
class ChatbotAnswerToolbarClicked {
    eventProperties;
    eventName = "chatbot_answer_toolbar_clicked";
    constructor(props) {
        this.eventProperties = {
            action: props.action,
            answer_id: props.answerId,
        };
    }
}
/**
 * @param paymentPlatform
 * @param paymentType
 * @param seats
 * @param trial
 */
class CheckoutFlowCompleted {
    eventProperties;
    eventName = "checkout_flow_completed";
    constructor(props) {
        this.eventProperties = {
            payment_platform: props.paymentPlatform,
            payment_type: props.paymentType ?? undefined,
            seats: props.seats ?? undefined,
            trial: props.trial,
        };
    }
}
/**
 * @param paymentPlatform
 * @param reason
 * @param seats
 * @param trial
 */
class CheckoutFlowFailed {
    eventProperties;
    eventName = "checkout_flow_failed";
    constructor(props) {
        this.eventProperties = {
            payment_platform: props.paymentPlatform,
            reason: props.reason,
            seats: props.seats ?? undefined,
            trial: props.trial,
        };
    }
}
/**
 * @param paymentPlatform
 * @param trial
 * @param type
 */
class CheckoutFlowIssue {
    eventProperties;
    eventName = "checkout_flow_issue";
    constructor(props) {
        this.eventProperties = {
            payment_platform: props.paymentPlatform,
            trial: props.trial,
            type: props.type,
        };
    }
}
/** @param reason */
class CheckoutFlowLoadError {
    eventProperties;
    eventName = "checkout_flow_load_error";
    constructor(props) {
        this.eventProperties = {
            reason: props.reason,
        };
    }
}
/** @param paymentPlatform */
class CheckoutFlowLoaded {
    eventProperties;
    eventName = "checkout_flow_loaded";
    constructor(props) {
        this.eventProperties = {
            payment_platform: props.paymentPlatform,
        };
    }
}
/**
 * @param autoOpen
 * @param projectId
 */
class DeeplinkAutoOpenToggled {
    eventProperties;
    eventName = "deeplink_auto_open_toggled";
    constructor(props) {
        this.eventProperties = {
            auto_open: props.autoOpen,
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkButtonClicked {
    eventProperties;
    eventName = "deeplink_button_clicked";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkButtonShown {
    eventProperties;
    eventName = "deeplink_button_shown";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkGoToDownload {
    eventProperties;
    eventName = "deeplink_go_to_download";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkModalClosed {
    eventProperties;
    eventName = "deeplink_modal_closed";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkModalOpened {
    eventProperties;
    eventName = "deeplink_modal_opened";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/**
 * @param autoOpen
 * @param projectId
 */
class DeeplinkOpenInitiated {
    eventProperties;
    eventName = "deeplink_open_initiated";
    constructor(props) {
        this.eventProperties = {
            auto_open: props.autoOpen,
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class DeeplinkRetryButtonClicked {
    eventProperties;
    eventName = "deeplink_retry_button_clicked";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/**
 * @param action
 * @param details
 * @param elementId
 * @param location
 */
class ElementClicked {
    eventProperties;
    eventName = "element_clicked";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
            details: props.details ?? undefined,
            element_id: props.elementId ?? undefined,
            location: props.location ?? undefined,
        };
    }
}
/**
 * @param action
 * @param details
 * @param location
 */
class ElementHovered {
    eventProperties;
    eventName = "element_hovered";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
            details: props.details ?? undefined,
            location: props.location ?? undefined,
        };
    }
}
/**
 * @param action
 * @param details
 * @param location
 */
class ErrorShown {
    eventProperties;
    eventName = "error_shown";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
            details: props.details ?? undefined,
            location: props.location ?? undefined,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 */
class GoToCollaborationPromo {
    eventProperties;
    eventName = "go_to_collaboration_promo";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location,
        };
    }
}
/**
 * @param activeTeamId
 * @param destination
 * @param location
 */
class GoToDashboard {
    eventProperties;
    eventName = "go_to_dashboard";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            destination: props.destination,
            location: props.location,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 */
class GoToMembers {
    eventProperties;
    eventName = "go_to_members";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 */
class GoToReviewLinks {
    eventProperties;
    eventName = "go_to_review_links";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 */
class GoToSharedWithMe {
    eventProperties;
    eventName = "go_to_shared_with_me";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location,
        };
    }
}
/**
 * @param activeTeamId
 * @param destination
 * @param location
 * @param role
 */
class GoToSpace {
    eventProperties;
    eventName = "go_to_space";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            destination: props.destination,
            location: props.location,
            role: props.role ?? undefined,
        };
    }
}
/**
 * @param activeTeamId
 * @param destination
 * @param location
 */
class GoToTeam {
    eventProperties;
    eventName = "go_to_team";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            destination: props.destination,
            location: props.location,
        };
    }
}
/** @param trigger */
class IntentPageFinished {
    eventProperties;
    eventName = "intent_page_finished";
    constructor(props) {
        this.eventProperties = {
            trigger: props.trigger ?? undefined,
        };
    }
}
/** */
class IntentPageLoaded {
    eventProperties;
    eventName = "intent_page_loaded";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}
/**
 * @param contributorBlockedEmailCount
 * @param emailCount
 * @param initiatedFrom
 * @param validEmailCount
 */
class InviteModalClosed {
    eventProperties;
    eventName = "invite_modal_closed";
    constructor(props) {
        this.eventProperties = {
            contributor_blocked_email_count: props.contributorBlockedEmailCount ?? undefined,
            email_count: props.emailCount ?? undefined,
            initiated_from: props.initiatedFrom,
            valid_email_count: props.validEmailCount ?? undefined,
        };
    }
}
/**
 * @param details
 * @param emailCount
 * @param role
 */
class InviteModalEmailAdded {
    eventProperties;
    eventName = "invite_modal_email_added";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            email_count: props.emailCount ?? undefined,
            role: props.role ?? undefined,
        };
    }
}
/**
 * @param details
 * @param emailCount
 */
class InviteModalEmailRemoved {
    eventProperties;
    eventName = "invite_modal_email_removed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            email_count: props.emailCount ?? undefined,
        };
    }
}
/**
 * @param contributorBlockedEmailCount
 * @param emailCount
 * @param formatInvalidEmailCount
 * @param memberInvalidEmailCount
 * @param recordedInvalidEmailCount
 * @param role
 * @param validEmailCount
 */
class InviteModalEstimateReceived {
    eventProperties;
    eventName = "invite_modal_estimate_received";
    constructor(props) {
        this.eventProperties = {
            contributor_blocked_email_count: props.contributorBlockedEmailCount ?? undefined,
            email_count: props.emailCount,
            format_invalid_email_count: props.formatInvalidEmailCount ?? undefined,
            member_invalid_email_count: props.memberInvalidEmailCount ?? undefined,
            recorded_invalid_email_count: props.recordedInvalidEmailCount ?? undefined,
            role: props.role,
            valid_email_count: props.validEmailCount ?? undefined,
        };
    }
}
/**
 * @param details
 * @param emailCount
 * @param reason
 * @param role
 */
class InviteModalInvalidEmailAdded {
    eventProperties;
    eventName = "invite_modal_invalid_email_added";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            email_count: props.emailCount ?? undefined,
            reason: props.reason ?? undefined,
            role: props.role ?? undefined,
        };
    }
}
/** @param role */
class InviteModalShown {
    eventProperties;
    eventName = "invite_modal_shown";
    constructor(props) {
        this.eventProperties = {
            role: props.role,
        };
    }
}
/**
 * @param contributorBlockedEmailCount
 * @param emailCount
 * @param role
 */
class InviteModalSubmitted {
    eventProperties;
    eventName = "invite_modal_submitted";
    constructor(props) {
        this.eventProperties = {
            contributor_blocked_email_count: props.contributorBlockedEmailCount ?? undefined,
            email_count: props.emailCount ?? undefined,
            role: props.role ?? undefined,
        };
    }
}
/**
 * @param action
 * @param details
 * @param location
 */
class ModalClosed {
    eventProperties;
    eventName = "modal_closed";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
            details: props.details ?? undefined,
            location: props.location ?? undefined,
        };
    }
}
/**
 * @param action
 * @param details
 * @param location
 */
class ModalShown {
    eventProperties;
    eventName = "modal_shown";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
            details: props.details ?? undefined,
            location: props.location ?? undefined,
        };
    }
}
/** @param lang */
class PageTranslated {
    eventProperties;
    eventName = "page_translated";
    constructor(props) {
        this.eventProperties = {
            lang: props.lang ?? undefined,
        };
    }
}
/**
 * @param isInsideIframe
 * @param referrer
 */
class PageVisited {
    eventProperties;
    eventName = "page_visited";
    constructor(props) {
        this.eventProperties = {
            is_inside_iframe: props.isInsideIframe ?? undefined,
            referrer: props.referrer,
        };
    }
}
/**
 * @param paywallReason
 * @param remoteProjectId
 */
class PaywallModalDismissed {
    eventProperties;
    eventName = "paywall_modal_dismissed";
    constructor(props) {
        this.eventProperties = {
            paywall_reason: props.paywallReason,
            remote_project_id: props.remoteProjectId,
        };
    }
}
/**
 * @param hasSubscribeAction
 * @param paywallReason
 * @param remoteProjectId
 */
class PaywallModalShown {
    eventProperties;
    eventName = "paywall_modal_shown";
    constructor(props) {
        this.eventProperties = {
            has_subscribe_action: props.hasSubscribeAction,
            paywall_reason: props.paywallReason,
            remote_project_id: props.remoteProjectId,
        };
    }
}
/**
 * @param paywallReason
 * @param remoteProjectId
 */
class PaywallSubscribeClicked {
    eventProperties;
    eventName = "paywall_subscribe_clicked";
    constructor(props) {
        this.eventProperties = {
            paywall_reason: props.paywallReason,
            remote_project_id: props.remoteProjectId,
        };
    }
}
/** @param durationMs */
class PriceFetched {
    eventProperties;
    eventName = "price_fetched";
    constructor(props) {
        this.eventProperties = {
            duration_ms: props.durationMs ?? undefined,
        };
    }
}
/** */
class ProgressiveProfilingCompleted {
    eventProperties;
    eventName = "progressive_profiling_completed";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}
/** @param nrOfCreators */
class ProgressiveProfilingStepCreatorsCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_creators_completed";
    constructor(props) {
        this.eventProperties = {
            nr_of_creators: props.nrOfCreators,
        };
    }
}
/** @param designStorage */
class ProgressiveProfilingStepDesignStorageCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_design_storage_completed";
    constructor(props) {
        this.eventProperties = {
            design_storage: props.designStorage,
        };
    }
}
/** @param industry */
class ProgressiveProfilingStepIndustryCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_industry_completed";
    constructor(props) {
        this.eventProperties = {
            industry: props.industry,
        };
    }
}
/** @param cadTool */
class ProgressiveProfilingStepMainCadCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_main_cad_completed";
    constructor(props) {
        this.eventProperties = {
            cad_tool: props.cadTool,
        };
    }
}
/** @param role */
class ProgressiveProfilingStepRoleCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_role_completed";
    constructor(props) {
        this.eventProperties = {
            role: props.role,
        };
    }
}
/** @param nrOfViewers */
class ProgressiveProfilingStepViewersCompleted {
    eventProperties;
    eventName = "progressive_profiling_step_viewers_completed";
    constructor(props) {
        this.eventProperties = {
            nr_of_viewers: props.nrOfViewers,
        };
    }
}
/**
 * @param projectId
 * @param projectTeamId
 * @param role
 */
class ProjectPageAccessRequestAccepted {
    eventProperties;
    eventName = "project_page_access_request_accepted";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
            project_team_id: props.projectTeamId,
            role: props.role,
        };
    }
}
/**
 * @param projectId
 * @param projectTeamId
 */
class ProjectPageAccessRequestRejected {
    eventProperties;
    eventName = "project_page_access_request_rejected";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
            project_team_id: props.projectTeamId,
        };
    }
}
/** @param projectId */
class ProjectPageAccessRequested {
    eventProperties;
    eventName = "project_page_access_requested";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/** @param projectId */
class ProjectPageAccessSwitchUser {
    eventProperties;
    eventName = "project_page_access_switch_user";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
        };
    }
}
/**
 * @param projectId
 * @param projectTeamId
 */
class ProjectPageDownloadFileClicked {
    eventProperties;
    eventName = "project_page_download_file_clicked";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
            project_team_id: props.projectTeamId,
        };
    }
}
/**
 * @param projectId
 * @param projectTeamId
 */
class ProjectPageDownloadFileShown {
    eventProperties;
    eventName = "project_page_download_file_shown";
    constructor(props) {
        this.eventProperties = {
            project_id: props.projectId,
            project_team_id: props.projectTeamId,
        };
    }
}
/**
 * @param featureTourType
 * @param projectId
 */
class ProjectPageFeatureTourClose {
    eventProperties;
    eventName = "project_page_feature_tour_close";
    constructor(props) {
        this.eventProperties = {
            feature_tour_type: props.featureTourType,
            project_id: props.projectId,
        };
    }
}
/**
 * @param featureTourType
 * @param projectId
 */
class ProjectPageFeatureTourCompleted {
    eventProperties;
    eventName = "project_page_feature_tour_completed";
    constructor(props) {
        this.eventProperties = {
            feature_tour_type: props.featureTourType,
            project_id: props.projectId,
        };
    }
}
/**
 * @param featureTourStep
 * @param featureTourType
 * @param projectId
 */
class ProjectPageFeatureTourStepShown {
    eventProperties;
    eventName = "project_page_feature_tour_step_shown";
    constructor(props) {
        this.eventProperties = {
            feature_tour_step: props.featureTourStep,
            feature_tour_type: props.featureTourType,
            project_id: props.projectId,
        };
    }
}
/**
 * @param accessStatus
 * @param hasReviewLink
 * @param notFound
 * @param projectId
 * @param projectTeamId
 */
class ProjectPageLoaded {
    eventProperties;
    eventName = "project_page_loaded";
    constructor(props) {
        this.eventProperties = {
            access_status: props.accessStatus ?? undefined,
            has_review_link: props.hasReviewLink ?? undefined,
            not_found: props.notFound ?? undefined,
            project_id: props.projectId,
            project_team_id: props.projectTeamId ?? undefined,
        };
    }
}
/**
 * @param configurationType
 * @param duration
 * @param startTime
 */
class RemoteConfigReceived {
    eventProperties;
    eventName = "remote_config_received";
    constructor(props) {
        this.eventProperties = {
            configuration_type: props.configurationType ?? undefined,
            duration: props.duration,
            start_time: props.startTime ?? undefined,
        };
    }
}
/** */
class RenewalTooltipShown {
    eventProperties;
    eventName = "renewal_tooltip_shown";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}
/** @param location */
class RequestVerificationEmailClicked {
    eventProperties;
    eventName = "request_verification_email_clicked";
    constructor(props) {
        this.eventProperties = {
            location: props.location ?? undefined,
        };
    }
}
/** */
class SegmentationSurveyCompletedV3 {
    eventProperties;
    eventName = "segmentation_survey_completed_v3";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}
/**
 * @param cadTools
 * @param details
 */
class SegmentationSurveyStepCadCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_cad_completed";
    constructor(props) {
        this.eventProperties = {
            cad_tools: props.cadTools,
            details: props.details ?? undefined,
        };
    }
}
/**
 * @param details
 * @param features
 */
class SegmentationSurveyStepFeaturesCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_features_completed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            features: props.features,
        };
    }
}
/**
 * @param details
 * @param industry
 */
class SegmentationSurveyStepIndustryCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_industry_completed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            industry: props.industry,
        };
    }
}
/** @param orgSize */
class SegmentationSurveyStepOrgSizeCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_org_size_completed";
    constructor(props) {
        this.eventProperties = {
            org_size: props.orgSize,
        };
    }
}
/**
 * @param details
 * @param userJobRole
 */
class SegmentationSurveyStepRoleCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_role_completed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            user_job_role: props.userJobRole,
        };
    }
}
/**
 * @param details
 * @param usageIntent
 */
class SegmentationSurveyStepUsageIntentCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_usage_intent_completed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            usage_intent: props.usageIntent,
        };
    }
}
/**
 * @param details
 * @param work
 */
class SegmentationSurveyStepWorkCompleted {
    eventProperties;
    eventName = "segmentation_survey_step_work_completed";
    constructor(props) {
        this.eventProperties = {
            details: props.details ?? undefined,
            work: props.work,
        };
    }
}
/** @param duration */
class SessionPaused {
    eventProperties;
    eventName = "session_paused";
    constructor(props) {
        this.eventProperties = {
            duration: props.duration ?? undefined,
        };
    }
}
/**
 * @param paymentPlatform
 * @param subscriptionPeriodChosen
 */
class SubscriptionPeriodSwitched {
    eventProperties;
    eventName = "subscription_period_switched";
    constructor(props) {
        this.eventProperties = {
            payment_platform: props.paymentPlatform,
            subscription_period_chosen: props.subscriptionPeriodChosen,
        };
    }
}
/** @param action */
class TwoFactorDisableModalAct {
    eventProperties;
    eventName = "two_factor_disable_modal_act";
    constructor(props) {
        this.eventProperties = {
            action: props.action ?? undefined,
        };
    }
}
/** @param paymentType */
class UpdatePaymentSourceSuccess {
    eventProperties;
    eventName = "update_payment_source_success";
    constructor(props) {
        this.eventProperties = {
            payment_type: props.paymentType,
        };
    }
}
/** */
class UrlChanged {
    eventProperties;
    eventName = "url_changed";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}
/** @param appTrackingId */
class UserLoggedIn {
    eventProperties;
    eventName = "user_logged_in";
    constructor(props) {
        this.eventProperties = {
            app_tracking_id: props.appTrackingId ?? undefined,
        };
    }
}
/**
 * @param appTrackingId
 * @param type
 */
class UserSignedUp {
    eventProperties;
    eventName = "user_signed_up";
    constructor(props) {
        this.eventProperties = {
            app_tracking_id: props.appTrackingId ?? undefined,
            type: props.type ?? undefined,
        };
    }
}
/**
 * @param from
 * @param videoId
 */
class VideoStarted {
    eventProperties;
    eventName = "video_started";
    constructor(props) {
        this.eventProperties = {
            from: props.from,
            video_id: props.videoId,
        };
    }
}
/**
 * @param reason
 * @param videoId
 */
class VideoStopped {
    eventProperties;
    eventName = "video_stopped";
    constructor(props) {
        this.eventProperties = {
            reason: props.reason,
            video_id: props.videoId,
        };
    }
}
/** @param activeTeamId */
class WebDashboardTeamSwitcherClicked {
    eventProperties;
    eventName = "web_dashboard_team_switcher_clicked";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId,
        };
    }
}
/**
 * @param activeTeamId
 * @param selectedTeamId
 */
class WebDashboardTeamSwitcherItemClicked {
    eventProperties;
    eventName = "web_dashboard_team_switcher_item_clicked";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId,
            selected_team_id: props.selectedTeamId,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param viewLinkId
 */
class WebDashboardViewLinkClicked {
    eventProperties;
    eventName = "web_dashboard_view_link_clicked";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            view_link_id: props.viewLinkId,
        };
    }
}
/**
 * @param action
 * @param activeTeamId
 * @param location
 * @param viewLinkId
 */
class WebDashboardViewLinkContextMenuActed {
    eventProperties;
    eventName = "web_dashboard_view_link_context_menu_acted";
    constructor(props) {
        this.eventProperties = {
            action: props.action,
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            view_link_id: props.viewLinkId,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param viewLinkId
 */
class WebDashboardViewLinkContextMenuOpened {
    eventProperties;
    eventName = "web_dashboard_view_link_context_menu_opened";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            view_link_id: props.viewLinkId,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param viewLinkId
 */
class WebDashboardViewLinkCopied {
    eventProperties;
    eventName = "web_dashboard_view_link_copied";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            view_link_id: props.viewLinkId,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param viewLinkId
 */
class WebDashboardViewLinkUnpublishConfirmed {
    eventProperties;
    eventName = "web_dashboard_view_link_unpublish_confirmed";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            view_link_id: props.viewLinkId,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param projectId
 * @param type
 * @param viewLinkId
 */
class WebLinkClicked {
    eventProperties;
    eventName = "web_link_clicked";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            project_id: props.projectId ?? undefined,
            type: props.type,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param action
 * @param activeTeamId
 * @param location
 * @param projectId
 * @param type
 * @param viewLinkId
 */
class WebLinkContextMenuActed {
    eventProperties;
    eventName = "web_link_context_menu_acted";
    constructor(props) {
        this.eventProperties = {
            action: props.action,
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            project_id: props.projectId ?? undefined,
            type: props.type,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param projectId
 * @param type
 * @param viewLinkId
 */
class WebLinkContextMenuOpened {
    eventProperties;
    eventName = "web_link_context_menu_opened";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            project_id: props.projectId ?? undefined,
            type: props.type,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param projectId
 * @param type
 * @param viewLinkId
 */
class WebLinkCopied {
    eventProperties;
    eventName = "web_link_copied";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            project_id: props.projectId ?? undefined,
            type: props.type,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param activeTeamId
 * @param location
 * @param type
 * @param viewLinkId
 */
class WebLinkUnpublishConfirmed {
    eventProperties;
    eventName = "web_link_unpublish_confirmed";
    constructor(props) {
        this.eventProperties = {
            active_team_id: props.activeTeamId ?? undefined,
            location: props.location ?? undefined,
            type: props.type,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalEmailAdded {
    eventProperties;
    eventName = "web_share_modal_email_added";
    constructor(props) {
        this.eventProperties = {
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalEmailRemoved {
    eventProperties;
    eventName = "web_share_modal_email_removed";
    constructor(props) {
        this.eventProperties = {
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalInvalidEmailAdded {
    eventProperties;
    eventName = "web_share_modal_invalid_email_added";
    constructor(props) {
        this.eventProperties = {
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param projectUserRole
 * @param remoteProjectId
 * @param role
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalInvitePressed {
    eventProperties;
    eventName = "web_share_modal_invite_pressed";
    constructor(props) {
        this.eventProperties = {
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            role: props.role ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param newValue
 * @param oldValue
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalInviteRoleChanged {
    eventProperties;
    eventName = "web_share_modal_invite_role_changed";
    constructor(props) {
        this.eventProperties = {
            new_value: props.newValue,
            old_value: props.oldValue,
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param affectedUserId
 * @param invitationId
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalMemberRemoveConfirmed {
    eventProperties;
    eventName = "web_share_modal_member_remove_confirmed";
    constructor(props) {
        this.eventProperties = {
            affected_user_id: props.affectedUserId ?? undefined,
            invitation_id: props.invitationId ?? undefined,
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param affectedUserId
 * @param invitationId
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalMemberRemoveIntended {
    eventProperties;
    eventName = "web_share_modal_member_remove_intended";
    constructor(props) {
        this.eventProperties = {
            affected_user_id: props.affectedUserId ?? undefined,
            invitation_id: props.invitationId ?? undefined,
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param affectedUserId
 * @param invitationId
 * @param newValue
 * @param oldValue
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param webExportId
 */
class WebShareModalMemberRoleChanged {
    eventProperties;
    eventName = "web_share_modal_member_role_changed";
    constructor(props) {
        this.eventProperties = {
            affected_user_id: props.affectedUserId ?? undefined,
            invitation_id: props.invitationId ?? undefined,
            new_value: props.newValue,
            old_value: props.oldValue,
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param projectUserRole
 * @param remoteProjectId
 * @param sharedResource
 * @param spaceId
 * @param teamUserRole
 * @param viewLinkId
 * @param visible
 * @param webExportId
 */
class WebShareModalVisibilityChanged {
    eventProperties;
    eventName = "web_share_modal_visibility_changed";
    constructor(props) {
        this.eventProperties = {
            project_user_role: props.projectUserRole ?? undefined,
            remote_project_id: props.remoteProjectId ?? undefined,
            shared_resource: props.sharedResource ?? undefined,
            space_id: props.spaceId ?? undefined,
            team_user_role: props.teamUserRole ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            visible: props.visible,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param initiatedFrom
 * @param newTool
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerActiveToolChanged {
    eventProperties;
    eventName = "web_viewer_active_tool_changed";
    constructor(props) {
        this.eventProperties = {
            initiated_from: props.initiatedFrom,
            new_tool: props.newTool,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param type
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerAnnotationPlaced {
    eventProperties;
    eventName = "web_viewer_annotation_placed";
    constructor(props) {
        this.eventProperties = {
            type: props.type,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param commentId
 * @param type
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerCommentAdded {
    eventProperties;
    eventName = "web_viewer_comment_added";
    constructor(props) {
        this.eventProperties = {
            comment_id: props.commentId,
            type: props.type,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param commentId
 * @param viewLinkId
 * @param visible
 * @param webExportId
 */
class WebViewerCommentContextMenuVisibilityChanged {
    eventProperties;
    eventName = "web_viewer_comment_context_menu_visibility_changed";
    constructor(props) {
        this.eventProperties = {
            comment_id: props.commentId,
            view_link_id: props.viewLinkId,
            visible: props.visible,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param commentId
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerCommentDeleteConfirmed {
    eventProperties;
    eventName = "web_viewer_comment_delete_confirmed";
    constructor(props) {
        this.eventProperties = {
            comment_id: props.commentId,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param commentId
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerCommentDeleteIntended {
    eventProperties;
    eventName = "web_viewer_comment_delete_intended";
    constructor(props) {
        this.eventProperties = {
            comment_id: props.commentId,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param commentId
 * @param source
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerCommentSelected {
    eventProperties;
    eventName = "web_viewer_comment_selected";
    constructor(props) {
        this.eventProperties = {
            comment_id: props.commentId,
            source: props.source,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerCommentingDisplayed {
    eventProperties;
    eventName = "web_viewer_commenting_displayed";
    constructor(props) {
        this.eventProperties = {
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param viewLinkId
 * @param visible
 */
class WebViewerCommentingSidebarVisibilityChanged {
    eventProperties;
    eventName = "web_viewer_commenting_sidebar_visibility_changed";
    constructor(props) {
        this.eventProperties = {
            view_link_id: props.viewLinkId,
            visible: props.visible,
        };
    }
}
/**
 * @param drawingId
 * @param viewLinkId
 */
class WebViewerDrawingDisplayFailed {
    eventProperties;
    eventName = "web_viewer_drawing_display_failed";
    constructor(props) {
        this.eventProperties = {
            drawing_id: props.drawingId ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param drawingId
 * @param durationMs
 * @param viewLinkId
 */
class WebViewerDrawingDisplayed {
    eventProperties;
    eventName = "web_viewer_drawing_displayed";
    constructor(props) {
        this.eventProperties = {
            drawing_id: props.drawingId ?? undefined,
            duration_ms: props.durationMs ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param drawingId
 * @param viewLinkId
 */
class WebViewerDrawingDownloadFailed {
    eventProperties;
    eventName = "web_viewer_drawing_download_failed";
    constructor(props) {
        this.eventProperties = {
            drawing_id: props.drawingId ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param drawingId
 * @param durationMs
 * @param viewLinkId
 */
class WebViewerDrawingDownloaded {
    eventProperties;
    eventName = "web_viewer_drawing_downloaded";
    constructor(props) {
        this.eventProperties = {
            drawing_id: props.drawingId ?? undefined,
            duration_ms: props.durationMs ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
        };
    }
}
/**
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerModelDisplayFailed {
    eventProperties;
    eventName = "web_viewer_model_display_failed";
    constructor(props) {
        this.eventProperties = {
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param durationMs
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerModelDisplayed {
    eventProperties;
    eventName = "web_viewer_model_displayed";
    constructor(props) {
        this.eventProperties = {
            duration_ms: props.durationMs ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerModelDownloadFailed {
    eventProperties;
    eventName = "web_viewer_model_download_failed";
    constructor(props) {
        this.eventProperties = {
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param durationMs
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerModelDownloaded {
    eventProperties;
    eventName = "web_viewer_model_downloaded";
    constructor(props) {
        this.eventProperties = {
            duration_ms: props.durationMs ?? undefined,
            view_link_id: props.viewLinkId ?? undefined,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param newValue
 * @param oldValue
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerShareModalGeneralPermissionChanged {
    eventProperties;
    eventName = "web_viewer_share_modal_general_permission_changed";
    constructor(props) {
        this.eventProperties = {
            new_value: props.newValue,
            old_value: props.oldValue,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param newValue
 * @param oldValue
 * @param viewLinkId
 * @param webExportId
 */
class WebViewerShareModalGeneralRoleChanged {
    eventProperties;
    eventName = "web_viewer_share_modal_general_role_changed";
    constructor(props) {
        this.eventProperties = {
            new_value: props.newValue,
            old_value: props.oldValue,
            view_link_id: props.viewLinkId,
            web_export_id: props.webExportId ?? undefined,
        };
    }
}
/**
 * @param reason
 * @param viewLinkId
 */
class WebViewerViewLinkAccessDenied {
    eventProperties;
    eventName = "web_viewer_view_link_access_denied";
    constructor(props) {
        this.eventProperties = {
            reason: props.reason,
            view_link_id: props.viewLinkId,
        };
    }
}
/** @param reason */
class WelcomeModalClosed {
    eventProperties;
    eventName = "welcome_modal_closed";
    constructor(props) {
        this.eventProperties = {
            reason: props.reason,
        };
    }
}
/** */
class WelcomeModalShown {
    eventProperties;
    eventName = "welcome_modal_shown";
    constructor(props = {}) {
        this.eventProperties = props;
    }
}

export { AddSeatsModalConfirmed, ApplePayButtonClicked, ApplePaySetupFailed, CampaignTouched, ChatbotAnswerLinkClicked, ChatbotAnswerToolbarClicked, CheckoutFlowCompleted, CheckoutFlowFailed, CheckoutFlowIssue, CheckoutFlowLoadError, CheckoutFlowLoaded, DeeplinkAutoOpenToggled, DeeplinkButtonClicked, DeeplinkButtonShown, DeeplinkGoToDownload, DeeplinkModalClosed, DeeplinkModalOpened, DeeplinkOpenInitiated, DeeplinkRetryButtonClicked, ElementClicked, ElementHovered, ErrorShown, GoToCollaborationPromo, GoToDashboard, GoToMembers, GoToReviewLinks, GoToSharedWithMe, GoToSpace, GoToTeam, IntentPageFinished, IntentPageLoaded, InviteModalClosed, InviteModalEmailAdded, InviteModalEmailRemoved, InviteModalEstimateReceived, InviteModalInvalidEmailAdded, InviteModalShown, InviteModalSubmitted, ModalClosed, ModalShown, PageTranslated, PageVisited, PaywallModalDismissed, PaywallModalShown, PaywallSubscribeClicked, PriceFetched, ProgressiveProfilingCompleted, ProgressiveProfilingStepCreatorsCompleted, ProgressiveProfilingStepDesignStorageCompleted, ProgressiveProfilingStepIndustryCompleted, ProgressiveProfilingStepMainCadCompleted, ProgressiveProfilingStepRoleCompleted, ProgressiveProfilingStepViewersCompleted, ProjectPageAccessRequestAccepted, ProjectPageAccessRequestRejected, ProjectPageAccessRequested, ProjectPageAccessSwitchUser, ProjectPageDownloadFileClicked, ProjectPageDownloadFileShown, ProjectPageFeatureTourClose, ProjectPageFeatureTourCompleted, ProjectPageFeatureTourStepShown, ProjectPageLoaded, RemoteConfigReceived, RenewalTooltipShown, RequestVerificationEmailClicked, SegmentationSurveyCompletedV3, SegmentationSurveyStepCadCompleted, SegmentationSurveyStepFeaturesCompleted, SegmentationSurveyStepIndustryCompleted, SegmentationSurveyStepOrgSizeCompleted, SegmentationSurveyStepRoleCompleted, SegmentationSurveyStepUsageIntentCompleted, SegmentationSurveyStepWorkCompleted, SessionPaused, SubscriptionPeriodSwitched, TwoFactorDisableModalAct, UpdatePaymentSourceSuccess, UrlChanged, UserLoggedIn, UserSignedUp, VideoStarted, VideoStopped, WebDashboardTeamSwitcherClicked, WebDashboardTeamSwitcherItemClicked, WebDashboardViewLinkClicked, WebDashboardViewLinkContextMenuActed, WebDashboardViewLinkContextMenuOpened, WebDashboardViewLinkCopied, WebDashboardViewLinkUnpublishConfirmed, WebLinkClicked, WebLinkContextMenuActed, WebLinkContextMenuOpened, WebLinkCopied, WebLinkUnpublishConfirmed, WebShareModalEmailAdded, WebShareModalEmailRemoved, WebShareModalInvalidEmailAdded, WebShareModalInvitePressed, WebShareModalInviteRoleChanged, WebShareModalMemberRemoveConfirmed, WebShareModalMemberRemoveIntended, WebShareModalMemberRoleChanged, WebShareModalVisibilityChanged, WebViewerActiveToolChanged, WebViewerAnnotationPlaced, WebViewerCommentAdded, WebViewerCommentContextMenuVisibilityChanged, WebViewerCommentDeleteConfirmed, WebViewerCommentDeleteIntended, WebViewerCommentSelected, WebViewerCommentingDisplayed, WebViewerCommentingSidebarVisibilityChanged, WebViewerDrawingDisplayFailed, WebViewerDrawingDisplayed, WebViewerDrawingDownloadFailed, WebViewerDrawingDownloaded, WebViewerModelDisplayFailed, WebViewerModelDisplayed, WebViewerModelDownloadFailed, WebViewerModelDownloaded, WebViewerShareModalGeneralPermissionChanged, WebViewerShareModalGeneralRoleChanged, WebViewerViewLinkAccessDenied, WelcomeModalClosed, WelcomeModalShown };
//# sourceMappingURL=web.schema.js.map
